import * as React from 'react';
import GoogleMapReact from 'google-maps-react-markers';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { BBox } from 'geojson';
import Config from '../../../../../../config';
import VehicleMarker from './VehicleMarker';
import { IPosition } from '../../../../../interfaces/map';
import { getMapSettings } from '../../../../../Services/UserService';
import GoogleMapsStyle from '../../../../OnlineMapNew/GoogleMapLayer/GoogleMapsStyle';
import { IPositionInGraph } from '../..';
import { boundsAtom, centerAtom, zoomAtom } from '../../../../OnlineMapNew/OnlineMapState';

function GoogleMapLayer(props: {
  position: IPositionInGraph | null;
  googleMap: google.maps.Map | undefined;
  vehicleId: number;
  setGoogleMap: React.Dispatch<React.SetStateAction<google.maps.Map | undefined>>;
}): JSX.Element {
  const setBounds = useSetRecoilState<BBox | undefined>(boundsAtom);
  const setZoom = useSetRecoilState<number>(zoomAtom);
  const center = useRecoilValue<IPosition>(centerAtom);
  const zoomLevel = useRecoilValue<number>(zoomAtom);

  return (
    <GoogleMapReact
      apiKey={Config.GoogleMaps.apiKey}
      libraries={Config.GoogleMaps.libraries}
      defaultCenter={{ lat: center.lat, lng: center.lng }}
      defaultZoom={zoomLevel}
      loadScriptExternally={true}
      status="ready"
      options={{
        streetViewControl: false,
        zoomControl: false,
        mapTypeControl: false,
        rotateControl: false,
        fullscreenControl: false,
        fullscreenControlOptions: {
          position: 2, // google.maps.ControlPosition.TOP_CENTER
        },
        streetViewControlOptions: {
          position: 9, // google.maps.ControlPosition.RIGHT_BOTTOM,
        },
        styles: GoogleMapsStyle, // Custom styles for Google Map
        disableDefaultUI: false, // Enable/disable default Google Maps UI
        clickableIcons: false, // Enable/disable clickable icons for POIsxw
        mapTypeId: getMapSettings().value.mapType || 'roadmap',
      }}
      onGoogleApiLoaded={({ map }) => {
        if (!props.googleMap) {
          props.setGoogleMap(map);
        }
      }}
      onChange={(event: any) => {
        setZoom(event.zoom);
        const sw = event.bounds.getSouthWest();
        const ne = event.bounds.getNorthEast();

        setBounds([sw.lng(), sw.lat(), ne.lng(), ne.lat()]);
      }}
    >
      {props.position && (
        <VehicleMarker
          lat={props.position.lat}
          lng={props.position.lng}
          status={props.position.status}
          mode={props.position.mode}
          angle={props.position.angle}
          zIndex={0}
          vehicleId={props.vehicleId}
        />
      )}
    </GoogleMapReact>
  );
}

export default React.memo(GoogleMapLayer);
